import React from "react";
import ScrollText from "../images/kv_scroll_text.svg";
import ScrollArrow from "../images/kv_scroll_arrow.svg";

const ScrollBtn = (props) => {
    const { mobileNavOpen } = props;

    return (
        <a
            className="scroll"
            href="/"
            onClick={(e) => {
                let element = document.querySelector("#tainanVideo");
                e.preventDefault();
                element && element.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
            rel="noreferrer"
        >
            <img className={`${mobileNavOpen ? "text" : "text z-index-up"}`} src={ScrollText} width={88} height={88} alt="scroll-text" />
            <img className={`${mobileNavOpen ? "arrow" : "arrow z-index-up"}`} src={ScrollArrow} width={31} height={88} alt="scroll-arrow" />
        </a>
    );
};

export default ScrollBtn;
